export default class Screen {
    constructor() {
        this.$main = document.getElementById('js-main');
        this.minHeight = 650;
        this.maxHeight = 743;
        this.init();
    }

    init() {
        // アプリボタンを設定
        this.setApp();

        // リサイズイベントを追加
        this.addResize();
    }

    setApp() {
        const windowHeight = window.innerHeight;

        let ratio = 0;

        if (windowHeight >= this.minHeight && this.maxHeight > windowHeight) {
            ratio = windowHeight / this.maxHeight;
        } else if (this.minHeight > windowHeight) {
            ratio = this.minHeight / this.maxHeight;
        }

        this.$main.style.transform = ratio ? 'scale(' + ratio + ')' : null;
    }

    addResize() {
        window.addEventListener('resize', () => {
            this.setApp();
        });
    }
}
